const showing_faq_answers = () => {
  $(".faq__question").click(function() {
    $(this)
      .next(".faq__answer")
      .slideToggle(300);
  });
};

export default showing_faq_answers;
